import {getUserByToken} from "../api/user";
import EventBus from '../api/event-bus.js';
export default class Auth {
  constructor() {
    this.currentUser = null;
    this.groups = [];
    let self = this;
    if(localStorage.getItem("JSTOKEN") != undefined) {
      getUserByToken().then(function(user){
        self.currentUser = user;
        // console.log("AUTH constructor");
        // console.log(self.currentUser);
        // console.log("AUTH logged on from constructor");
        EventBus.$emit("logon", true);
      })
        .catch(function() {
          self.currentUser = null;
          EventBus.$emit("logon", false);
        })
    }
  }

  setUser(user) {
    this.currentUser = user;
  }
  refreshUser() {

    console.log("setUser");
    if (localStorage.getItem("JSTOKEN") != undefined) {
      let self = this;
      getUserByToken().then(function (user) {
        self.currentUser = user;
        // console.log("AUTH logged on from setUser");
        // console.log(self.currentUser);
        // EventBus.$emit("logon", true);
        //self.getOtherUserList();
      });
    }
  }

  isUserManager() {
    if(this.currentUser == null) {
      return false;
    }
    if(this.currentUser.role === 'admin' || this.currentUser.role === 'manager') {
      return true;
    }
  }

  getUser() {
    return this.currentUser;
  }
}



// WEBPACK FOOTER //
// ./src/store/auth.js